<template>
  <div
    v-if="
      (!model.postValidateDraftStatus &&
        !model.is_campaign_template &&
        !campaignSaveAsTemplate) ||
        !dialog
    "
    class="info-block"
    style="display: block"
  >
    <el-row style="margin-bottom: 10px">
      <el-col :span="9">
        <div class="est-wrapper">
          <div class="label">
            {{ $t('CampaignForm_ReviewDialog_Recipients') }}
          </div>
          <div class="msg">
            <span data-qa="calculated-recipients-count">{{
              calculatedRecipients
            }}</span>
            <i
              class="el-icon-refresh el-icon-spin"
              @click="startCalculate"
              :class="{ disabled: recipients.polling }"
              data-qa="refresh-calculated-recipients-btn"
            />
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="label">
          {{ $t('CampaignForm_ReviewDialog_Schedule') }}
        </div>
        <div class="msg" v-if="isSendLaterCampaign">
          {{ sendLaterMessage }}
        </div>
        <div class="msg" v-else>
          {{ $t(sendTypes[model.send_type]) }}
        </div>
      </el-col>
    </el-row>
    <el-alert
      type="info"
      v-if="recipients.descriptiveCountTime && recipients.polling"
    >
      <i class="el-icon-info" />
      {{ $t('CampaignForm_CalculateRecipients_Placeholder_Counting') }}
      {{
        $t('CampaignForm_CalculateRecipients_Placeholder_Count_Started', {
          time: `${new Date(
            recipients.descriptiveCountTime * 1000
          ).toLocaleDateString('en-GB')} ${new Date(
            recipients.descriptiveCountTime * 1000
          ).toLocaleTimeString('en-GB')}`
        })
      }}
      {{ $t('CampaignForm_CalculateRecipients_Placeholder_Check') }}
      <router-link :to="taskViewRoute" target="_blank">
        {{ $t('CampaignForm_CalculateRecipients_Placeholder_Link') }}
      </router-link>
    </el-alert>
    <el-alert
      type="info"
      v-else-if="calculatedRecipients !== '-' && calculatedRecipients !== '?'"
    >
      <i class="el-icon-info" />
      {{
        $t('CampaignForm_CalculateRecipients_Placeholder_Counting_Done', {
          time: `${new Date(
            recipients.descriptiveCountTime * 1000
          ).toLocaleDateString('en-GB')} ${new Date(
            recipients.descriptiveCountTime * 1000
          ).toLocaleTimeString('en-GB')}`
        })
      }}
      <span v-if="recipients.count.sampling_level">
        {{
          $t('CampaignForm_CalculateRecipients_Placeholder_Counting_Sampled')
        }},
        <span class="link" @click="startCalculateExact">
          {{
            $t(
              'CampaignForm_CalculateRecipients_Placeholder_Counting_ClickHere'
            )
          }}
        </span>
      </span>
    </el-alert>
  </div>
</template>

<script>
import { projectRoute } from '@/core/helpers'
import { campaignSendTypeEnum } from '@/modules/campaigns/enum/CampaignSendTypeEnums'
import { mapGetters } from 'vuex'

export default {
  name: 'ScheduleInfo',
  props: {
    model: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: false,
      default: () => {}
    },
    dialog: {
      type: Boolean,
      required: false,
      default: false
    },
    recipients: {
      type: Object,
      required: true
    },
    campaignSaveAsTemplate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      campaignSendTypeEnum,
      calculatedRecipients: '-',
      sendTypes: {
        0: 'CampaignForm_Schedule_ScheduleSelector_SendNow_Title',
        1: 'CampaignForm_Schedule_ScheduleSelector_SendLater_Title',
        2: 'CampaignForm_Schedule_ScheduleSelector_Repeat_Title'
      }
    }
  },
  computed: {
    ...mapGetters(['timezones']),

    recipientsByChannel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    taskViewRoute() {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: this.recipients.taskId }
      })
    },
    sendLaterMessage() {
      if (this.model.send_date == null || this.model.send_time == null) {
        return this.$t('CampaignForm_Schedule_ScheduleSelector_SendLater_Title')
      }

      const [hour, minute] = this.model.send_time
        .split(':')
        .map(x => Number.parseInt(x))

      const [year, month, day] = this.model.send_date.split('-')
      const sendDateTime = new Date(year, month - 1, day, hour, minute)

      let timezone = 'User Timezone'
      if (this.model.timezone !== '') {
        timezone = this.model.timezone
      }

      const dateTime = sendDateTime.toLocaleString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })

      let tz = timezone
      if (timezone in this.timezones) {
        tz = this.timezones[timezone]
      }

      return this.$t(
        'CampaignForm_Schedule_ScheduleSelector_SendLater_Details',
        {
          date_time: dateTime,
          timezone: tz
        }
      )
    },
    isSendLaterCampaign() {
      return this.model.send_type === campaignSendTypeEnum.SEND_TYPE_FUTURE
    }
  },
  mounted() {
    this.$emit('check')
    this.changeUICount(this.recipients.count)
  },
  beforeDestroy() {
    this.$set(this.recipients, 'interruptPing', true)
    clearTimeout(this.recipients.statusTimeout)
  },
  methods: {
    startCalculate() {
      this.$emit('calculate', true)
    },
    startCalculateExact() {
      this.$emit('calculate', false)
    },
    changeUICount(count) {
      this.recipientsByChannel = {}
      if (this.recipients.polling || this.recipients.buttonsDisabled) {
        this.calculatedRecipients = '-'
      } else if (Object.keys(count.message_type).length === 0) {
        this.calculatedRecipients = '?'
      } else {
        this.recipientsByChannel = { ...this.recipients.count.message_type }
        if (this.recipients.count.message_type[13] !== undefined) {
          this.calculatedRecipients = this.recipients.count.message_type[13]
        } else {
          this.calculatedRecipients = Object.values(
            this.recipients.count.message_type
          ).reduce((a, b) => a + b, 0)
        }
      }
    }
  },
  watch: {
    recipients: {
      handler: function() {
        this.changeUICount(this.recipients.count)
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
.info-block {
  border: 1px solid #dbdee7;
  padding: 20px;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .est {
    min-width: 250px;
  }
  .el-icon-refresh {
    padding-left: 4px;
    margin-top: 2px;
    cursor: pointer;
    color: #1d87c8;
    font-size: 20px;
    &.disabled {
      color: #c0c4cc;
      pointer-events: none;
      cursor: not-allowed;
      &.el-icon-spin {
        width: 20px;
        height: 20px;
        padding: 2px;
        margin: 0;
        animation: spin 2s reverse infinite linear;
      }
    }
  }
  .label {
    font-size: 12px;
    color: #7e8596;
  }
  .msg {
    display: inline-block;
    align-items: center;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #4b515f;
  }
  .est-wrapper {
    width: fit-content;
    text-align: left;
  }
  .el-alert {
    word-break: break-word;
    text-align: left;
    i {
      margin-left: -5px;
      margin-bottom: 5px;
      margin-right: 5px;
    }
    .link {
      color: #4b515f;
      cursor: pointer;
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/review/ScheduleInfo.vue